import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=16c95383&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=16c95383&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c95383",
  null
  
)

export default component.exports